module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('span', {
    staticStyle: {
      "color": "grey"
    }
  }, [_vm._v(_vm._s(_vm.settings.path))]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.element.value || '',
      "auto-height": true
    },
    on: {
      "change": _vm.htmlChanged
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576c99fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LookupDialog.vue
// module id = 2555
// module chunks = 1